import '../attachment/Divider.css';

export default function Divider() {
    return (
        <div className='Divider'>
            <div class="lineContainer">
                <div class="lines">
                    <div class="circle"></div>
                </div>
            </div>
        </div>
    )
}